import axios from 'axios';

export interface MicroTrendFiltersRequest {
  retailerId: number;
  startWeekId: number;
  endWeekId: number;
}

export interface ProductTagFilter {
  label: string;
  values: string[];
}

export interface MicroTrendFiltersResponse {
  trendId: string;
  categoryIds: number[];
  subcategoryIds: number[];
  brandIds: number[];
  productTagFilters: ProductTagFilter[];
  found: boolean;
  debug?: {
    query: string;
    queryExecutionTime: number;
    queryContextCreationTime: number;
    isCacheHit: boolean;
    cacheResponseTime: number;
    topicGroupAnnotationTime: number;
  };
}

export interface ProductsWithSalesDataRequest {
  metricType: string;
  fieldName: string;
  retailerId: number;
  categoryIds: number[];
  subcategoryIds: number[];
  brandIds: number[];
  segmentIds: number[];
  businessunitids: number[];
  resultCount: number;
  trendIds: string[];
  startWeekId: number;
  endWeekId: number;
  sortby: string;
}

export interface ProductSku {
  stacklineSku: string;
  fieldKey: string;
  productName?: string;
  brandName?: string;
  // Add other fields as needed
}

export interface ProductsWithSalesDataResponse {
  records: ProductSku[];
}

export const microTrendsServerProxy = {
  /**
   * Fetches the filters associated with a microtrend
   * @param trendId - The ID of the microtrend
   * @param requestBody - Additional request parameters
   * @returns The microtrend filters including categoryIds and brandIds
   */
  getTrendFilters: async (
    trendId: string,
    requestBody: MicroTrendFiltersRequest
  ): Promise<MicroTrendFiltersResponse> => {
    const response = await axios({
      method: 'GET',
      url: `/api/atlas/microtrends/GetTrendFilters/${trendId}`,
      data: requestBody
    });
    return response.data;
  },

  /**
   * Fetches the product SKUs for a trend
   * @param requestBody - Request parameters for getting products with sales data
   * @returns The products with sales data
   */
  getProductSkus: async (requestBody: ProductsWithSalesDataRequest): Promise<ProductsWithSalesDataResponse> => {
    const response = await axios({
      method: 'POST',
      url: '/api/atlas/sales/GetSalesMetrics',
      data: requestBody
    });
    return response.data;
  }
};
